import { ApiClientError } from "./api";

/** Transport/provider internals are not useful instructions for a family. */
export function requestErrorMessage(error: Error, isArabic: boolean) {
  if (error instanceof TypeError || (error instanceof ApiClientError && error.status >= 500)) {
    return isArabic ? "تعذر الاتصال بكيديكس الآن. أعد المحاولة بعد قليل." : "We could not connect to Kidix right now. Please try again shortly.";
  }
  if (isArabic && error instanceof ApiClientError) {
    const authenticationErrors: Record<string, string> = {
      INVALID_CREDENTIALS: "تحقق من بيانات تسجيل الدخول وحاول مرة أخرى.",
      MFA_CHALLENGE_INVALID: "رمز التحقق غير صحيح أو انتهت صلاحيته. تحقق منه أو ابدأ تسجيل الدخول من جديد.",
      MFA_CHALLENGE_USED: "استُخدم رمز التحقق بالفعل. ابدأ تسجيل الدخول من جديد.",
      TOKEN_EXPIRED: "انتهت صلاحية هذا الرابط. اطلب رابطًا جديدًا.",
      TOKEN_USED: "استُخدم هذا الرابط بالفعل. اطلب رابطًا جديدًا إذا احتجت إليه.",
      INVALID_TOKEN: "هذا الرابط غير صالح. افتح الرابط الكامل من بريدك أو اطلب رابطًا جديدًا.",
      AUTH_REQUIRED: "انتهت جلستك. سجل الدخول مرة أخرى.",
      SESSION_EXPIRED: "انتهت جلستك. سجل الدخول مرة أخرى.",
      RECENT_AUTHENTICATION_REQUIRED: "سجل الدخول من جديد وأكد رمز البريد لمتابعة هذا الإجراء الحساس.",
      MFA_REQUIRED: "سجل الدخول من جديد وأدخل رمز التحقق المرسل إلى بريدك.",
      EXPORT_SCOPE_FORBIDDEN: "لا يسمح دورك بالوصول إلى فئة البيانات هذه.",
      EXPORT_REVIEW_CONFLICT: "تمت مراجعة هذا الطلب بالفعل. حدّث حالة التصدير.",
      EXPORT_APPROVAL_EXPIRED: "انتهت مهلة مراجعة الطلب. اطلب تصديرًا جديدًا.",
      EXPORT_REQUESTER_UNAUTHORIZED: "لم يعد مقدم الطلب مخوّلًا لهذا التصدير. لا يمكن اعتماده.",
      EXPORT_REVIEW_REQUIRED: "يتطلب التصدير مراجعة مستقلة مطابقة. راجع قائمة التصدير أو اطلب ملفًا جديدًا.",
      INVALID_LEGAL_HOLD_TARGET: "اختر سجلًا موجودًا ضمن فئة الاحتفاظ المحددة.",
      COVERAGE_ASSIGNMENT_REQUIRED: "رتّب تكليفًا مقبولًا وفعالًا يغطي الجلسة قبل الموافقة على البديل.",
      LEAVE_COVERAGE_INCOMPLETE: "حدد إجراءً لكل جلسة متأثرة. حدّث القائمة إذا تغيرت الجلسات.",
    };
    const translated = error.code ? authenticationErrors[error.code] : undefined;
    if (translated) return translated;
  }
  return error.message;
}
